export default __webpack_public_path__ + "static/media/nepal3.3157c213.jpg";